import { Button, Snackbar } from "@mui/material";
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Fragment, useState } from "react";


const CopyExcelDataButton = ({ elementId, style, sx, onClickStart=async() => {}, onClickEnd=async() => {} }) => {

  const [showSnackbar, setShowSnackbar] = useState(false);

  function currencyToFloat(value) {
    if (typeof value !== "string") return value;

    // Match supported currencies at the start: S$, $, €, £
    const currencyPattern = /^(S\$|\$|€|£)/;

    // If it doesn't start with a valid currency, return as is
    if (!currencyPattern.test(value.trim())) {
      return value;
    }

    // Remove known currency symbols
    let cleaned = value.replace(/^(S\$|\$|€|£)/, "");

    // Remove commas and spaces
    cleaned = cleaned.replace(/,/g, "").trim();

    console.log(cleaned);

    // Convert to float
    return parseFloat(cleaned);
  }

  return (
    <Fragment>
      <Button
        size='small'
        style={style}
        sx={sx}
        onClick={async () => {
          await onClickStart();

          var node = document.getElementById(elementId);

          node = node.cloneNode(true);

          const tds = node.getElementsByTagName("td");

          const trs = node.getElementsByTagName("tr");

          // remove any row with class 'row-not-included-in-excel'
          for (let i = trs.length - 1; i >= 0; i--) {
            if (trs[i].classList.contains("row-not-included-in-excel")) {
              trs[i].parentNode.removeChild(trs[i]);
            }
          }

          for (let i = 0; i < tds.length; i++) {
            // tds[i].style.border = '';

            // remove any input, svg, fieldset
            const inputs = tds[i].getElementsByTagName("input");
            for (let j = 0; j < inputs.length; j++) {
              inputs[j].parentNode.removeChild(inputs[j]);
            }

            const svgs = tds[i].getElementsByTagName("svg");
            for (let j = 0; j < svgs.length; j++) {
              svgs[j].parentNode.removeChild(svgs[j]);
            }

            const fieldsets = tds[i].getElementsByTagName("fieldset");
            for (let j = 0; j < fieldsets.length; j++) {
              fieldsets[j].parentNode.removeChild(fieldsets[j]);
            }

            tds[i].innerHTML = currencyToFloat(tds[i].innerHTML.trim());
          }


          const blob = new Blob([node.outerHTML], { type: "text/html" });
          const clipboardItem = new ClipboardItem({ "text/html": blob });

          await navigator.clipboard.write([clipboardItem]);

          setShowSnackbar(true);

          await onClickEnd();
        }}
        endIcon={<ContentCopyIcon />}
      >
        Copy Excel Data
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={showSnackbar}
        autoHideDuration={2500}
        onClose={() => setShowSnackbar(false)}
        message="Excel Data Copied to Clipboard. You can paste it into Excel, Google Sheets, or Outlook."
      />
    </Fragment>
  );
};

export default CopyExcelDataButton;